export const mergeModuleAccess = ({ roleAccess, extraAccess }) => {
  const merged = {};
  const keys = new Set([
    ...Object.keys(roleAccess),
    ...Object.keys(extraAccess),
  ]);
  keys.forEach((key) => {
    const roleModules = roleAccess[key] || [];
    const extraModules = extraAccess[key] || [];
    const map = new Map();
    [...roleModules, ...extraModules].forEach((module) => {
      const normalizedPath = module.path?.replace(/\/$/, "") || "";
      if (!map.has(normalizedPath)) {
        map.set(normalizedPath, {
          ...module,
          children: [...(module.children || [])],
        });
      } else {
        const existing = map.get(normalizedPath);
        const newChildren = module.children || [];
        newChildren.forEach((child) => {
          if (!existing.children.some((c) => c.path === child.key)) {
            existing.children.push({ ...child });
          }
        });
      }
    });
    merged[key] = Array.from(map.values());
  });
  return merged;
};

export const filterNavByModuleAccess = ({
  moduleAccess = {},
  navData = [],
  accessKey = "ats",
  role = null,
}) => {
  if (role === 1) return navData;
  const allowedPaths = moduleAccess?.[accessKey]?.map((m) => m.key);

  return navData
    .map((item) => {
      if (item.subMenus && item.subMenus.length > 0) {
        const filteredSubMenus = item.subMenus.filter(
          (sub) => sub.id && allowedPaths?.includes(sub.id)
        );
        if (filteredSubMenus.length > 0) {
          return { ...item, subMenus: filteredSubMenus };
        }
        return null;
      } else {
        if (item.id && allowedPaths?.includes(item.id)) {
          return item;
        }
        return null;
      }
    })
    .filter(Boolean);
};

// export const getTabsByPath = ({
//   moduleAccess = {},
//   parentId,
//   accessKey = "ats",
// }) => {
//   if (!moduleAccess || !parentId) return [];



//   const parentModule = moduleAccess?.[accessKey]?.find(
//     (mod) => mod.key === parentId
//   );
//   return parentModule?.children || [];
// };
// export const filterRoutes = ({
//   routes = [],
//   modules = {},
//   role = null,
//   accessKey = "ats",
// }) => {
//   if (role === 1) return routes;
//   if (!Array.isArray(routes) || !Array.isArray(modules[accessKey])) return [];
//   const allowedKeys = modules[accessKey]
//     .filter((module) => module.type === 1 && module.key)
//     .map((module) => module.key.trim().toLowerCase());
//   return routes.filter(
//     (route) => route.id && allowedKeys.includes(route.id.trim().toLowerCase())
//   );
// };
// export const getTabsByPath = ({
//   moduleAccess = {},
//   parentId,
//   accessKey = "ats",
// }) => {
//   if (!moduleAccess || !parentId) return [];
//   const keys = parentId.split("_");
//   let currentLevel = moduleAccess?.[accessKey] || [];
//   for (const key of keys) {
//     const found = currentLevel.find((mod) => mod.key === key);
//     if (!found) {
//       return [];
//     }
//     currentLevel = found.children || [];
//   }
//   return currentLevel;
// };
export const getTabsByPath = ({
  moduleAccess = {},
  parentId,
  accessKey = "ats",
}) => {
  if (!moduleAccess || !parentId) return [];

  let currentLevel = moduleAccess[accessKey] || [];

  // Traverse recursively to find the node with matching key
  const findNodeByKey = (nodes, key) => {
    for (const node of nodes) {
      if (node.key === key) return node;
      if (node.children && node.children.length > 0) {
        const found = findNodeByKey(node.children, key);
        if (found) return found;
      }
    }
    return null;
  };

  const node = findNodeByKey(currentLevel, parentId);
  return node?.children || [];
};


export const filterRoutes = ({
  routes = [],
  modules = {},
  role = null,
  accessKey = "ats",
  userModule,
  portal
}) => {
  // if (role === 1) return Array.isArray(routes) ? routes : [];
  if (!Array.isArray(routes)) return [];
  if(role === 1) {
    if (userModule === 1) {
      return routes;
    };
    const MODULE_PORTAL_MAP = {
      2: "ats",
      3: "wf",
      4: "bs",
    };
    const allowedPortal = MODULE_PORTAL_MAP[userModule];
    if (portal && allowedPortal === portal) {
      return routes;
    }
    return [];
  }

  if (!modules || !Array.isArray(modules[accessKey])) return [];
  const allowedKeys = modules[accessKey]
    .filter((module) => module && module.type === 1 && module.key)
    .map((module) => module.key.trim().toLowerCase())
    .filter(Boolean);
  return routes.filter(
    (route) =>
      route && route.id && allowedKeys.includes(route.id.trim().toLowerCase())
  );
};
